import { render } from "./NotificationCard.vue?vue&type=template&id=00b6d7b8&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"

import "./NotificationCard.vue?vue&type=style&index=0&id=00b6d7b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00b6d7b8"

export default script